import { render, staticRenderFns } from "./addPropaganda.vue?vue&type=template&id=6a808698&scoped=true"
import script from "./addPropaganda.vue?vue&type=script&lang=js"
export * from "./addPropaganda.vue?vue&type=script&lang=js"
import style0 from "./addPropaganda.vue?vue&type=style&index=0&id=6a808698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a808698",
  null
  
)

export default component.exports